import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'userManagementExperience.list'

const UserManagementUserListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default UserManagementUserListSlice
